/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Sub_Addons_Confirm_Upgrade_Title_NewInputs */



/**
* | output |
* | --- |
* | "Add {label} storage" |
*
* @param {Sub_Addons_Confirm_Upgrade_Title_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_upgrade_title_new = /** @type {((inputs: Sub_Addons_Confirm_Upgrade_Title_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Upgrade_Title_NewInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.label} Speicher hinzufügen`)
	return /** @type {LocalizedString} */ (`Add ${i?.label} storage`)
});